import { mimeTypes } from './mimeTypes'

export const allowedPrintableMimeTypes = [
  ...Object.values(mimeTypes.document),
  ...Object.values(mimeTypes.spreadsheet),
  ...Object.values(mimeTypes.pdf),
  ...Object.values(mimeTypes.presentation),
  ...Object.values(mimeTypes.image)
]
